export const formatDuration = duration => {
  const time = duration.split(":");
  if (time.length > 2) {
    return `${time[0]} hr ${time[1]} min`;
  }
  return time[0] === "0" ? `${time[1]} sec` : `${time[0]} min`;
};
